module.exports = __webpack_public_path__ + "static/media/Matka-Kulfi-By-Vadilal.422cb48b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/Matka-Kulfi-By-Vadilal.gif
// module id = 311
// module chunks = 0